<template>
  <div v-if="visible" class="celebration-overlay" ref="overlay">
    <div class="container">
      <div id="mensaje" :class="{ hidden: !showCelebration }">{{ celebrationData.mensaje }}</div>
      <div id="vendedor" :class="{ hidden: !showCelebration }">{{ celebrationData.vendedor }}</div>
      <div id="monto" :class="{ hidden: !showCelebration }">{{ celebrationData.monto | moneda }}</div>
    </div>

    <!-- Contenedor para efectos visuales -->
    <div class="effects-container" ref="effectsContainer"></div>
  </div>
</template>

<script>
export default {
  name: 'Celebration',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    celebrationData: {
      type: Object,
      default: () => ({
        mensaje: '',
        vendedor: '',
        monto: ''
      })
    }
  },
  data() {
    return {
      showCelebration: false,
      balloons: [],
      confetti: []
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.startCelebration();
      } else {
        this.clearScreen();
      }
    }
  },
  methods: {
    startCelebration() {
      console.log('🎉 Iniciando celebración...');

      this.showCelebration = true;

      this.$nextTick(() => {
        this.createBalloons();
        this.createConfetti();
      });
    },
    clearScreen() {
      this.showCelebration = false;
      // Limpiar efectos visuales
      this.balloons.forEach(balloon => balloon.remove());
      this.confetti.forEach(confetti => confetti.remove());
      this.balloons = [];
      this.confetti = [];
    },
    createBalloons() {
      const colors = ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#ffeaa7', '#dda0dd'];

      for (let i = 0; i < 15; i++) {
        const balloon = document.createElement('div');
        balloon.className = 'balloon';
        balloon.style.left = Math.random() * 100 + '%';
        balloon.style.top = Math.random() * 100 + '%';
        balloon.style.background = colors[Math.floor(Math.random() * colors.length)];
        balloon.style.animationDelay = Math.random() * 2 + 's';
        balloon.style.animationDuration = (Math.random() * 3 + 3) + 's';
        if (this.$refs.effectsContainer) {
          this.$refs.effectsContainer.appendChild(balloon);
        }
        this.balloons.push(balloon);

        setTimeout(() => {
          balloon.remove();
          this.balloons = this.balloons.filter(b => b !== balloon);
        }, 8000);
      }
    },
    createConfetti() {
      for (let i = 0; i < 50; i++) {
        const confetti = document.createElement('div');
        confetti.className = 'confetti';
        confetti.style.left = Math.random() * 100 + '%';
        confetti.style.animationDelay = Math.random() * 3 + 's';
        confetti.style.animationDuration = (Math.random() * 2 + 2) + 's';
        if (this.$refs.effectsContainer) {
          this.$refs.effectsContainer.appendChild(confetti);
        }
        this.confetti.push(confetti);

        setTimeout(() => {
          confetti.remove();
          this.confetti = this.confetti.filter(c => c !== confetti);
        }, 5000);
      }
    },
  }
};
</script>

<style>
.celebration-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.container {
  text-align: center;
  z-index: 10;
  position: relative;
}

.effects-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 5;
}

#mensaje {
  font-size: 4rem;
  color: #fff;
  text-shadow: 4px 4px 0px #ff6b6b, 8px 8px 0px #4ecdc4;
  animation: pulse 2s infinite;
  margin-bottom: 1rem;
  display: block;
}

#atencion {
  font-size: 8rem;
  color: #ff0000;
  text-shadow: 4px 4px 0px #000, 8px 8px 0px #ff6b6b, 12px 12px 0px #ffff00;
  animation: attentionPulse 0.5s infinite;
  margin-bottom: 2rem;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

@keyframes attentionPulse {
  0% { transform: translate(-50%, -50%) scale(1); }
  50% { transform: translate(-50%, -50%) scale(1.2); }
  100% { transform: translate(-50%, -50%) scale(1); }
}

#vendedor {
  font-size: 6rem;
  color: #ffd700;
  text-shadow: 4px 4px 0px #ff6b6b, 8px 8px 0px #333;
  margin-bottom: 1rem;
  animation: bounce 1s infinite;
  display: block;
}

#monto {
  font-size: 4.5rem;
  color: #00ff88;
  text-shadow: 3px 3px 0px #0066cc;
  animation: glow 2s ease-in-out infinite alternate;
  display: block;
}

.waiting {
  font-size: 3rem;
  color: #fff;
  text-shadow: 2px 2px 0px #333;
}

/* Animaciones */
@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-20px); }
  60% { transform: translateY(-10px); }
}

@keyframes glow {
  from { text-shadow: 3px 3px 0px #0066cc, 0 0 20px #00ff88; }
  to { text-shadow: 3px 3px 0px #0066cc, 0 0 30px #00ff88, 0 0 40px #00ff88; }
}

/* Globos */
.balloon {
  position: absolute;
  width: 60px;
  height: 80px;
  border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
  animation: float 6s ease-in-out infinite;
}

.balloon::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  height: 20px;
  background: #333;
}

@keyframes float {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(5deg); }
}

/* Confeti */
.confetti {
  position: absolute;
  width: 10px;
  height: 10px;
  background: #ff6b6b;
  animation: confetti-fall 3s linear infinite;
}

.confetti:nth-child(odd) {
  background: #4ecdc4;
  animation-delay: 0.5s;
}

.confetti:nth-child(3n) {
  background: #45b7d1;
  animation-delay: 1s;
}

.confetti:nth-child(4n) {
  background: #96ceb4;
  animation-delay: 1.5s;
}

.confetti:nth-child(5n) {
  background: #ffeaa7;
  animation-delay: 2s;
}

@keyframes confetti-fall {
  0% {
    transform: translateY(-100vh) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(100vh) rotate(720deg);
    opacity: 0;
  }
}

/* Fuegos artificiales */
.firework {
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  animation: firework 2s ease-out infinite;
}

@keyframes firework {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(20);
    opacity: 0;
  }
}

.hidden {
  display: none !important;
  opacity: 0;
  visibility: hidden;
}
</style>